import {
  useUserContext 
} from "@/context/user"
import {
  useRouter 
} from "next/navigation"
import {
  useCallback, useEffect 
} from "react"

/**
 * @typedef {function} useForgotPasswordPage
 *
 * @param {String} props.signedInRedirectUrl - Url to push when user is signed in
 * @param {String} props.signInPageUrl - Sign In Page url
 *
 * @returns {{
 *   forgotPasswordProps: object
 * }}
 */
export const useForgotPasswordPage = (props) => {
  const {
    signedInRedirectUrl = "/customer/account", signInPageUrl = "/sign-in" 
  } =
        props
  const router = useRouter()
  const [{
    isSignedIn 
  }] = useUserContext()

  // Redirect if user is signed in
  useEffect(() => {
    if (isSignedIn && signedInRedirectUrl) {
      router.push(signedInRedirectUrl)
    }
  }, [router, isSignedIn, signedInRedirectUrl])

  const handleOnCancel = useCallback(() => {
    if (signInPageUrl) {
      router.push(signInPageUrl)
    }
  }, [router, signInPageUrl])

  const forgotPasswordProps = {
    onCancel: handleOnCancel,
  }

  return {
    forgotPasswordProps,
  }
}
